(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[26],{

/***/ 3313:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard",
      function () {
        return __webpack_require__(1843);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1843:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Dashboard; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./components/eth/Utils.ts
var Utils = __webpack_require__(1322);
// EXTERNAL MODULE: ./components/store/index.ts + 2 modules
var store = __webpack_require__(953);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(9521);
// EXTERNAL MODULE: ./components/store/getters.ts
var getters = __webpack_require__(4478);
;// CONCATENATED MODULE: ./components/containers/dashboard/Table.styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  justify-content: space-between;\n  display: flex;\n  button,\n  a {\n    display: inline-block;\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  visibility: hidden;\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @keyframes Pulsate {\n    from {\n      opacity: 1;\n    }\n    50% {\n      opacity: 0.75;\n    }\n    to {\n      opacity: 1;\n    }\n  }\n  height: 2.4rem;\n  width: 60%;\n  background: ",
        ";\n  border-radius: ",
        ";\n  animation: Pulsate 0.5s ease-in infinite;\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  box-shadow: ",
        ";\n  border-radius: ",
        ";\n  padding: 0 0 1rem 0;\n  & > section {\n    overflow-x: auto;\n    min-height: 240px;\n  }\n  margin-bottom: 100px;\n  td:first-child,\n  th:first-child {\n    padding-left: 3.2rem;\n  }\n  td:last-child,\n  th:last-child {\n    padding-right: 3.2rem;\n  }\n  table {\n    width: ",
        ";\n    text-align: left;\n    border-collapse: collapse;\n    font-size: 1.4rem;\n    @media (max-width: ",
        ") {\n      font-size: 1.3rem;\n    }\n  }\n  thead {\n    height: 70px;\n    box-shadow: inset 0 -2px 0 0 ",
        ";\n    @media (max-width: ",
        ") {\n      height: 60px;\n    }\n  }\n  tbody {\n    width: 100%;\n    overflow: hidden;\n    tr {\n      height: 100px;\n      @media (max-width: ",
        ") {\n        height: 80px;\n      }\n      td {\n        box-shadow: inset 0 -2px 0 0 ",
        ";\n      }\n    }\n    tr:last-child {\n      td {\n        box-shadow: none;\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}

const ActionsWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c59acf7d-0"
})(_templateObject());
const ButtonsWrapper = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-c59acf7d-1"
})(_templateObject1());
const LoadingSpacer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c59acf7d-2"
})(_templateObject2(), (param)=>{
    let { theme  } = param;
    return theme.colors.functional.gray3;
}, (param)=>{
    let { theme  } = param;
    return theme.borderRadius.sm;
});
const TableWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-c59acf7d-3"
})(_templateObject3(), (param)=>{
    let { theme  } = param;
    return theme.colors.functional.white;
}, (param)=>{
    let { theme  } = param;
    return theme.boxShadow.blue;
}, (param)=>{
    let { theme  } = param;
    return theme.borderRadius.main;
}, (param)=>{
    let { theme  } = param;
    return theme.container.lg;
}, (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.functional.gray3;
}, (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
}, (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.functional.gray3;
});

// EXTERNAL MODULE: ./components/common/Link/index.tsx + 1 modules
var Link = __webpack_require__(157);
// EXTERNAL MODULE: ./components/common/Tooltip.tsx
var Tooltip = __webpack_require__(5191);
;// CONCATENATED MODULE: ./components/containers/dashboard/PositionTableHead.styles.ts

function PositionTableHead_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  th {\n    width: 175px;\n  }\n  th:last-child {\n    width: auto;\n"
    ]);
    PositionTableHead_styles_templateObject = function() {
        return data;
    };
    return data;
}

const TableHead = styled_components_browser_esm/* default.thead.withConfig */.ZP.thead.withConfig({
    componentId: "sc-36878c25-0"
})(PositionTableHead_styles_templateObject());

;// CONCATENATED MODULE: ./components/containers/dashboard/PositionTableHead.tsx





function PositionTableHead() {
    const positionLifetimeInDays = (0,getters/* useGetPositionLifetimeInDays */.IB)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableHead, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                    scope: "col",
                    children: "Opened"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                    scope: "col",
                    children: "Collateral"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                    scope: "col",
                    children: "Borrowed"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                    scope: "col",
                    children: "Total Position Value"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                    scope: "col",
                    children: "Interest Earned"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("th", {
                    scope: "col",
                    children: [
                        "Expires",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                            position: "center",
                            name: "DashExpiry",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    "Positions automatically expire/unwind ",
                                    positionLifetimeInDays,
                                    " days after the open date. Your funds (collateral + earnings) can then be claimed any time on the",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                        href: "/dashboard",
                                        className: "font-bold underline",
                                        children: "My Dashboard"
                                    }),
                                    " ",
                                    "page."
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                    scope: "col",
                    children: "\xa0"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                    scope: "col"
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./components/common/Button/index.tsx + 1 modules
var Button = __webpack_require__(4918);
;// CONCATENATED MODULE: ./components/containers/dashboard/Table.tsx

function Table_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    Table_templateObject = function() {
        return data;
    };
    return data;
}










const StyledDataCell = styled_components_browser_esm/* default.td.withConfig */.ZP.td.withConfig({
    componentId: "sc-af6687ff-0"
})(Table_templateObject(), (param)=>{
    let { expiringSoon , theme: { colors: { secondary: { red  }  }  }  } = param;
    return expiringSoon && "\n    color: ".concat(red, ";\n    font-weight: 700;\n  ");
});
function Table(param) {
    let { openPositions  } = param;
    const positionLifetimeInDays = (0,getters/* useGetPositionLifetimeInDays */.IB)();
    // Before we show the modal, we need to load the correct data
    function closePosition(nftId) {
        const activePosition = openPositions.find((position)=>position.nftId === nftId);
        store/* dappStore.setState */.Rt.setState({
            activePositionId: nftId,
            activePosition,
            isClosePositionModal: true
        });
    }
    function viewDetails(nftId) {
        // console.log('called viewDetails');
        const activePosition = openPositions.find((position)=>position.nftId === nftId);
        store/* dappStore.setState */.Rt.setState({
            activePositionId: nftId,
            isViewNft: true,
            activePosition
        });
    }
    // Todo: refactor table
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PositionTableHead, {}),
                    (!openPositions || openPositions.length === 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("tr", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                colSpan: 7,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    children: "We don't see any open positions associated with your wallet."
                                })
                            })
                        })
                    }),
                    openPositions.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                        children: openPositions.map((position)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: moment_default().unix(position.unixTimestampOpened).format("MMM DD, YYYY")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                        children: [
                                            (0,Utils/* naturalNumber */.Rf)(position.collateral),
                                            " OUSD"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                        children: [
                                            (0,Utils/* naturalNumber */.Rf)(position.ousdBorrowed),
                                            " OUSD"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("td", {
                                        children: [
                                            (0,Utils/* naturalNumber */.Rf)(position.ousdTotalWithoutInterest),
                                            " OUSD"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: parseFloat((0,Utils/* naturalNumber */.Rf)(position.totalInterestEarned)) > 0 ? (0,Utils/* naturalNumber */.Rf)(position.totalInterestEarned) + " OUSD" : "--"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledDataCell, {
                                        expiringSoon: position.lifetimeInDays < 8,
                                        children: moment_default().unix(position.unixTimestampOpened + position.lifetimeInDays * 86400).format("MMM DD, YYYY")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ActionsWrap, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    variant: "thick",
                                                    onClick: ()=>viewDetails(position.nftId),
                                                    children: "Details"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                    variant: "thick",
                                                    onClick: ()=>closePosition(position.nftId),
                                                    children: "Close"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }, position.nftId))
                    })
                ]
            })
        })
    });
}

;// CONCATENATED MODULE: ./components/containers/dashboard/LoadingTable.tsx



function TR() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpacer, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpacer, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpacer, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpacer, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpacer, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpacer, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ButtonsWrapper, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            children: "Details"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            children: "Close"
                        })
                    ]
                })
            })
        ]
    });
}
function LoadingTable() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PositionTableHead, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TR, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TR, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TR, {})
                        ]
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/eth/PositionInfo.ts
var PositionInfo = __webpack_require__(2690);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./components/icons/index.js + 56 modules
var icons = __webpack_require__(2667);
// EXTERNAL MODULE: ./components/common/Modal/Modal.styles.ts
var Modal_styles = __webpack_require__(4941);
;// CONCATENATED MODULE: ./components/common/modals/MobileModal.styles.ts

function MobileModal_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  @media (max-width: ",
        ") {\n    display: block;\n  }\n"
    ]);
    MobileModal_styles_templateObject = function() {
        return data;
    };
    return data;
}
function MobileModal_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: auto;\n"
    ]);
    MobileModal_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function MobileModal_styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  @media (max-width: ",
        ") {\n    display: block;\n  }\n"
    ]);
    MobileModal_styles_templateObject2 = function() {
        return data;
    };
    return data;
}
function MobileModal_styles_templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: none;\n  padding: 5vh;\n  background: ",
        ";\n  position: fixed;\n  top: 5vh;\n  left: 5vh;\n  right: 5vh;\n  bottom: 5vh;\n  z-index: ",
        ";\n  border-radius: ",
        ";\n  box-shadow: ",
        ";\n  button {\n    padding: 2rem 0;\n    white-space: nowrap;\n    display: flex;\n    align-items: center;\n    font-weight: 700;\n    color: ",
        ";\n    fill: ",
        ";\n    & > span {\n      display: flex;\n      svg {\n        margin-right: 1rem;\n        width: 2.4rem;\n        height: 2.4rem;\n        transform: rotate(180deg);\n      }\n    }\n  }\n  @media (max-width: ",
        ") {\n    display: block;\n  }\n"
    ]);
    MobileModal_styles_templateObject3 = function() {
        return data;
    };
    return data;
}


const MobileContainer = (0,styled_components_browser_esm/* default */.ZP)(Modal_styles/* Container */.W2).withConfig({
    componentId: "sc-59f259ee-0"
})(MobileModal_styles_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.breakPoints.md;
});
const MobileContent = (0,styled_components_browser_esm/* default */.ZP)(Modal_styles/* Content */.VY).withConfig({
    componentId: "sc-59f259ee-1"
})(MobileModal_styles_templateObject1());
const MobileBackdrop = (0,styled_components_browser_esm/* default */.ZP)(Modal_styles/* Backdrop */.YM).withConfig({
    componentId: "sc-59f259ee-2"
})(MobileModal_styles_templateObject2(), (param)=>{
    let { theme  } = param;
    return theme.breakPoints.md;
});
const MobileWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-59f259ee-3"
})(MobileModal_styles_templateObject3(), (param)=>{
    let { theme  } = param;
    return theme.colors.functional.white;
}, (param)=>{
    let { theme  } = param;
    return theme.zIndex.backdrop + 1;
}, (param)=>{
    let { theme  } = param;
    return theme.borderRadius.main;
}, (param)=>{
    let { theme  } = param;
    return theme.boxShadow.blue;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.primary.main;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.primary.main;
}, (param)=>{
    let { theme  } = param;
    return theme.breakPoints.md;
});

;// CONCATENATED MODULE: ./components/common/modals/MobileModal.tsx




function MobileModal() {
    const router = (0,next_router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileBackdrop, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileContainer, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileWrapper, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(MobileContent, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                onClick: ()=>router.back(),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* ArrowRight */.ol, {})
                                    }),
                                    " ",
                                    "Back"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Switch to desktop view to view your dashboard."
                            })
                        ]
                    })
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/common/Modal/index.tsx + 2 modules
var Modal = __webpack_require__(1344);
// EXTERNAL MODULE: ./components/common/Typography/index.tsx + 1 modules
var Typography = __webpack_require__(990);
;// CONCATENATED MODULE: ./components/containers/dashboard/Dashboard.styles.ts

function Dashboard_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 4rem 0 190px;\n"
    ]);
    Dashboard_styles_templateObject = function() {
        return data;
    };
    return data;
}
function Dashboard_styles_templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  padding: 2rem 0;\n"
    ]);
    Dashboard_styles_templateObject1 = function() {
        return data;
    };
    return data;
}
function Dashboard_styles_templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: space-between;\n  padding: 2rem 0;\n  & > section {\n    h4 {\n      display: flex;\n      align-items: center;\n      color: ",
        ";\n    }\n    & > span {\n      display: flex;\n      align-items: center;\n      padding-left: 3.2rem;\n    }\n    svg {\n      display: flex;\n      align-items: center;\n      width: 2.4rem;\n      margin-left: 1rem;\n      cursor: pointer;\n    }\n    display: flex;\n    align-items: center;\n    color: ",
        ";\n  }\n  @media (max-width: ",
        ") {\n    font-size: 1.3rem;\n    & > section {\n      & > span {\n        padding-left: 2rem;\n      }\n  }\n"
    ]);
    Dashboard_styles_templateObject2 = function() {
        return data;
    };
    return data;
}


const Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-243d4792-0"
})(Dashboard_styles_templateObject());
const PageTitle = (0,styled_components_browser_esm/* default */.ZP)(Typography/* Typography */.Z).withConfig({
    componentId: "sc-243d4792-1"
})(Dashboard_styles_templateObject1());
const NavWrapper = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    componentId: "sc-243d4792-2"
})(Dashboard_styles_templateObject2(), (param)=>{
    let { theme  } = param;
    return theme.colors.functional.darkestGray;
}, (param)=>{
    let { theme  } = param;
    return theme.colors.functional.darkGray;
}, (param)=>{
    let { theme  } = param;
    return theme.breakPoints.lg;
});

// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var dist = __webpack_require__(9077);
// EXTERNAL MODULE: ./node_modules/@rainbow-me/rainbowkit/dist/chunk-GEBDUYT7.js + 33 modules
var chunk_GEBDUYT7 = __webpack_require__(6279);
// EXTERNAL MODULE: ./components/common/Container/index.tsx + 1 modules
var Container = __webpack_require__(7987);
;// CONCATENATED MODULE: ./components/common/RefreshButton.styles.ts

function RefreshButton_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 24px;\n  height: 24px;\n  && svg {\n    width: 100%;\n    height: 100%;\n    margin: 0;\n  }\n  ",
        ";\n"
    ]);
    RefreshButton_styles_templateObject = function() {
        return data;
    };
    return data;
}

const Spinner = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-eba69190-0"
})(RefreshButton_styles_templateObject(), (param)=>{
    let { loading  } = param;
    return loading == "true" && "animation: spin 0.5s linear infinite";
});

;// CONCATENATED MODULE: ./components/common/RefreshButton.tsx



const RefreshButton = (param)=>{
    let { loading  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Spinner, {
        loading: loading,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconRefresh */.tr, {})
    });
};

;// CONCATENATED MODULE: ./components/common/SortButton.styles.ts

function SortButton_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n"
    ]);
    SortButton_styles_templateObject = function() {
        return data;
    };
    return data;
}

const SortButton_styles_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-72a20204-0"
})(SortButton_styles_templateObject(), (param)=>{
    let { sort  } = param;
    return "\n    ".concat(sort !== "newest" && "transform: scaleY(-1)", "\n  ");
});

;// CONCATENATED MODULE: ./components/common/SortButton.tsx



const SortButton = (param)=>{
    let { sort  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SortButton_styles_Wrapper, {
        sort: sort,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* IconSort */.B4, {})
    });
};

// EXTERNAL MODULE: ./hooks/useModal.tsx + 15 modules
var useModal = __webpack_require__(9441);
;// CONCATENATED MODULE: ./pages/dashboard/dashboard.styles.ts

function dashboard_styles_templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n  @media (max-width: ",
        ") {\n    display: none;\n  }\n"
    ]);
    dashboard_styles_templateObject = function() {
        return data;
    };
    return data;
}


const StyledButton = (0,styled_components_browser_esm/* default */.ZP)(Button/* default */.Z).withConfig({
    componentId: "sc-7663b9f7-0"
})(dashboard_styles_templateObject(), (param)=>{
    let { theme  } = param;
    return theme.breakPoints.md;
});

;// CONCATENATED MODULE: ./pages/dashboard/index.page.tsx



















function Dashboard() {
    const [isLoaded, setIsLoaded] = (0,react.useState)(false);
    const { isConnected  } = (0,dist/* useAccount */.mA)();
    (0,react.useEffect)(()=>{
        setIsLoaded(true);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTitle, {
                        type: "h2",
                        children: "My Dashboard"
                    }),
                    isLoaded && isConnected && /*#__PURE__*/ (0,jsx_runtime.jsx)(PositionsSection, {}),
                    isLoaded && !isConnected && /*#__PURE__*/ (0,jsx_runtime.jsx)(NotLoggedView, {})
                ]
            })
        })
    });
}
function NotLoggedView() {
    const { openConnectModal  } = (0,chunk_GEBDUYT7/* useConnectModal */.We)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "\xa0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Switch to desktop view to view your dashboard"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "\xa0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledButton, {
                onClick: openConnectModal,
                children: "Connect Wallet"
            })
        ]
    });
}
function PositionsSection() {
    const [openPositions, setOpenPositions] = (0,react.useState)([]);
    const [sort, setSort] = (0,react.useState)("newest");
    const [loading, setLoading] = (0,react.useState)(false);
    const contracts = (0,getters/* useContracts */.GP)();
    const closePositionModalOpened = (0,getters/* useIsClosePositionModal */.bq)();
    const wrongNetworkModalOpened = (0,getters/* useIsWrongNetwork */.QL)();
    const { isConnected , address  } = (0,dist/* useAccount */.mA)();
    const { isModalOpen , modalTitle , modalComponent , titleIconName , showLoader , closeModal , hideCloseButton  } = (0,useModal/* useModal */.d)();
    const loadPositionsFromChain = async ()=>{
        // console.log('called loadPositionsFromChain');
        try {
            if (isConnected && !wrongNetworkModalOpened && (contracts === null || contracts === void 0 ? void 0 : contracts.positionToken)) {
                setLoading(true);
                const positions = await (0,PositionInfo/* getOpenPositions */.s)(contracts, address);
                setOpenPositions(positions);
                store/* userStore.setState */.HP.setState({
                    positions: positions
                });
                setLoading(false);
            }
        } catch (err) {
            setLoading(false);
            console.log("loadPositionsFromChain error: ", err);
        }
    };
    // We can use the closePositionModalOpened store to refresh the data
    (0,react.useEffect)(()=>{
        if (contracts === null || contracts === void 0 ? void 0 : contracts.positionToken) loadPositionsFromChain();
    }, [
        contracts,
        closePositionModalOpened
    ]);
    const sortHandler = ()=>{
        // For now just toggle text between newest and oldest
        // TODO sort the actual data
        const newSort = sort === "newest" ? "oldest" : "newest";
        setSort(newSort);
    };
    // We want a minimum time needed to load the data
    // Otherwise the animation is too jumpy
    // Not too long though, so 1 seconds (1000ms)
    const timeoutRef = (0,react.useRef)(null);
    const refreshHandler = ()=>{
        setLoading(true);
        if (window && window.setTimeout) {
            if (timeoutRef.current) clearInterval(timeoutRef.current);
            timeoutRef.current = window.setTimeout(()=>{
                loadPositionsFromChain();
            }, 1000);
        }
    };
    const sortedPositions = (0,react.useMemo)(()=>{
        if (!(openPositions === null || openPositions === void 0 ? void 0 : openPositions.length)) return [];
        if (sort === "newest") return [
            ...openPositions
        ].reverse();
        return openPositions;
    }, [
        openPositions,
        sort
    ]);
    function renderNav() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(NavWrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h4", {
                            children: [
                                "Open Positions",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    onClick: refreshHandler,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RefreshButton, {
                                        loading: loading.toString()
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            onClick: sortHandler,
                            children: [
                                "Sort by:",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                    children: sort
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SortButton, {
                                    sort: sort
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                openPositions.length,
                                " Open Positions"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/open-position",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        children: "Open New"
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        children: [
            renderNav(),
            !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(Table, {
                openPositions: sortedPositions
            }),
            loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingTable, {}),
            isModalOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
                title: modalTitle,
                onClose: closeModal,
                withLoader: showLoader,
                hideCloseButton: hideCloseButton,
                titleIcon: titleIconName,
                children: modalComponent
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileModal, {})
        ]
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [675,236,509,774,888,179], function() { return __webpack_exec__(3313); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);